import store from '../index.js';
import WebMidi from 'webmidi';
import { midiAccess } from "../data/actions";
import { Reverb } from './class-reverb';
import ir from '../sounds/minster1_000_ortf_48k.wav';

// browser detection
var AudioContext = window.AudioContext // Default
    || window.webkitAudioContext // Safari and old versions of Chrome
    || false; 

if (AudioContext) {
    var ctx = new AudioContext();
} else {
    alert("Sorry, but the Web Audio API is not supported by your browser. Please, consider upgrading to the latest version or downloading Google Chrome or Mozilla Firefox");
}

export const audioContext = ctx;
export const reverb = new Reverb(ctx, ir);

// // ROUTING
export const outputDry = audioContext.createGain();
outputDry.connect(audioContext.destination);
outputDry.gain.setValueAtTime(0.5, audioContext.currentTime);
export const outputWet = audioContext.createGain();
outputWet.connect(reverb.reverb);
outputWet.gain.setValueAtTime(0.3, audioContext.currentTime);


// MIDI

export const enableMidi = () => {
	return WebMidi.enable(function(err) {
			if (!err) {
				console.log('midi enabled');
		  		store.dispatch(midiAccess(WebMidi));
			} else {
				console.log('no midi enabled');
			}
		}, true);		
}

// enableMidi();






// WEBPACK FOOTER //
// ./src/synths/audio-setup.js